import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function PricingSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="precio" className="py-16 sm:py-24 bg-white" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="text-center mb-12 sm:mb-16" data-id="element-205">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-206">
            Planes simples y transparentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-207">Sin contratos. Sin sorpresas.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16 items-stretch" data-id="element-208">
          {/* Plan de prueba (Gratis) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="bg-gray-50 rounded-2xl border border-gray-200 p-6 sm:p-8 shadow-sm flex flex-col" data-id="element-209">
            <div className="mb-6" data-id="element-210">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-211">
                Plan de prueba
              </h3>
              <div className="flex items-baseline mb-1" data-id="element-212">
                <span className="text-3xl font-bold text-gray-900" data-id="element-213">Gratis</span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-214">para siempre</p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-215">
              <li className="flex items-start text-sm text-gray-700" data-id="element-216">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-217" />1
                usuario
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-218">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-219" />
                Hasta 3 informes al mes
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-220">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-221" />
                Máximo 1 obra
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-222">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-223" />
                Watermark "creado con InspectIA"
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-224">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-225" />
                Plantilla básica
              </li>
            </ul>
            <button onClick={scrollToContact} className="w-full py-2.5 px-4 rounded-md text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-226">
              Probar gratis
            </button>
          </motion.div>

          {/* Starter */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 shadow-sm flex flex-col" data-id="element-227">
            <div className="mb-6" data-id="element-228">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-229">Starter</h3>
              <div className="flex items-baseline mb-1" data-id="element-230">
                <span className="text-3xl font-bold text-gray-900" data-id="element-231">
                  USD $19
                </span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-232">/usuario/mes</p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-233">
              <li className="flex items-start text-sm text-gray-700" data-id="element-234">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-235" />
                Uso completo desde WhatsApp
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-236">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-237" />
                Generación automática de informes PDF
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-238">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-239" />
                Envío de fotos, audios y notas
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-240">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-241" />
                Historial de informes
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-242">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-243" />
                Hasta 20 informes/mes por usuario
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-244">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-245" />
                Hasta 10 obras activas
              </li>
            </ul>
            <button onClick={scrollToContact} className="w-full py-2.5 px-4 rounded-md text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-246">
              Comenzar
            </button>
          </motion.div>

          {/* Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl border-2 border-blue-600 p-6 sm:p-8 shadow-md flex flex-col relative transform lg:-translate-y-4" data-id="element-247">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-248">
              Más popular
            </div>
            <div className="mb-6" data-id="element-249">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-250">Pro</h3>
              <div className="flex items-baseline mb-1" data-id="element-251">
                <span className="text-3xl font-bold text-gray-900" data-id="element-252">
                  USD $29
                </span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-253">/usuario/mes</p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-254">
              <li className="flex items-start text-sm text-gray-700 font-medium" data-id="element-255">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-256" />
                Todo en Starter, más:
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-257">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-258" />
                Informes ilimitados
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-259">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-260" />
                Obras ilimitadas
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-261">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-262" />
                Plantillas personalizadas
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-263">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-264" />
                Branding de empresa en informes
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-265">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-266" />
                Organización por obra
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-267">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-268" />
                Descarga historial completo
              </li>
            </ul>
            <button onClick={scrollToContact} className="w-full py-2.5 px-4 rounded-md text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors" data-id="element-269">
              Comenzar con Pro
            </button>
          </motion.div>

          {/* Equipo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 shadow-sm flex flex-col" data-id="element-270">
            <div className="mb-6" data-id="element-271">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-272">Equipo</h3>
              <div className="flex items-baseline mb-1" data-id="element-273">
                <span className="text-3xl font-bold text-gray-900" data-id="element-274">
                  USD $249
                </span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-275">/obra/mes</p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-276">
              <li className="flex items-start text-sm text-gray-700" data-id="element-277">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-278" />
                Hasta 15 usuarios
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-279">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-280" />
                Informes ilimitados
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-281">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-282" />
                Solo una Obra
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-283">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-284" />
                Panel de control de proyectos
              </li>
              <li className="flex items-start text-sm text-gray-700" data-id="element-285">
                <Check className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-286" />
                Gestión centralizada de inspectores
              </li>
              <li className="flex items-start text-sm text-gray-500 mt-4 pt-4 border-t border-gray-100" data-id="element-287">
                Usuarios extra: USD $15/usuario
              </li>
            </ul>
            <button onClick={scrollToContact} className="w-full py-2.5 px-4 rounded-md text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-288">
              Contactar ventas
            </button>
          </motion.div>
        </div>

        {/* Enterprise note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="text-center text-sm text-gray-500 mb-10" data-id="element-289">
          ¿Organización grande?{' '}
          <span className="font-semibold text-gray-700" data-id="element-290">
            Enterprise desde USD $999/mes.
          </span>{' '}
          <button onClick={scrollToContact} className="text-blue-600 hover:text-blue-700 font-medium underline underline-offset-2 transition-colors" data-id="element-291">
            Contactar ventas
          </button>
        </motion.p>

        {/* Data availability banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="max-w-3xl mx-auto bg-blue-50 border border-blue-100 rounded-2xl p-6 sm:p-8 text-center" data-id="element-292">
          <p className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-293">
            Toda tu información, disponible para siempre.
          </p>
          <p className="text-sm sm:text-base text-gray-600" data-id="element-294">
            Independiente del plan que elijas, tus datos, fotos, audios e
            informes quedan guardados y accesibles en todo momento.
          </p>
        </motion.div>
      </div>
    </section>;
}